import apiAxios from '@/services/axiosConfig';
import type { UpdatePerformanceRequest, UpdatePerformanceResponse } from '@/types/api';

async function updatePerformanceCredentials(
  connectionUuid: string,
  data: UpdatePerformanceRequest
): Promise<UpdatePerformanceResponse> {
  const response = await apiAxios.put<UpdatePerformanceResponse>(
    `/api/v1/mt/connections/${connectionUuid}/performance`,
    data
  );
  return response.data;
}

export default updatePerformanceCredentials;
